class Slider {
  constructor() {
    this.init();
  }

  /* eslint-disable class-methods-use-this, no-unused-vars */
  init() {
    const that = this;

    Promise.all([
      import(/* webpackChunkName: "library-swiper" */ "swiper"),
      import(
        /* webpackChunkName: "library-swiper-modules" */ "swiper/modules" // eslint-disable-line
      ),
    ])
      .then(([{ default: Swiper }, { Navigation, Pagination }]) => {
        Array.from(document.querySelectorAll(".slider-gallery")).forEach((el) =>
          this.initSliderGallery(el, that, Swiper, Navigation)
        );
        Array.from(document.querySelectorAll(".projects")).forEach((el) =>
          this.initProjectsGallery(el, that, Swiper, Navigation)
        );
        Array.from(document.querySelectorAll(".customers-feedback")).forEach(
          (el) => this.initSliderCustomersFeedback(Swiper, Pagination)
        );
      })
      .catch((err) => console.log(err)); // eslint-disable-line
  }

  initSliderGallery(el, that, Swiper, Navigation) {
    /* eslint-disable no-unused-vars, no-undef */
    const sliderSection = new Swiper(".slider-gallery .swiper-container", {
      modules: [Navigation],

      // Optional parameters
      spaceBetween: 24,
      freeMode: true,
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: "auto",

      // Progress
      on: {
        progress(progress) {
          const swiper = el;
          that.progress(swiper, progress, el);
        },
      },

      // Navigation arrows
      navigation: {
        nextEl: ".js-slider-gallery-button-next",
        prevEl: ".js-slider-gallery-button-prev",
      },
    });
    /* eslint-enable no-unused-vars, no-undef */
  }

  initProjectsGallery(el, that, Swiper, Navigation) {
    /* eslint-disable no-unused-vars, no-undef */
    const sliderSection = new Swiper(".projects .swiper-container", {
      modules: [Navigation],

      // Optional parameters
      spaceBetween: 16,
      slidesPerView: 1,
      speed: 400,

      // Breakpoints
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 4.5,
        },
      },

      // Progress
      on: {
        progress(progress) {
          const swiper = el;
          that.progress(swiper, progress, el);
        },
      },

      // Navigation arrows
      navigation: {
        nextEl: ".js-projects-button-next",
        prevEl: ".js-projects-button-prev",
      },
    });
    /* eslint-enable no-unused-vars, no-undef */
  }

  initSliderCustomersFeedback(Swiper, Pagination) {
    /* eslint-disable no-unused-vars, no-undef */
    const customersFeedbackSection = new Swiper(
      ".customers-feedback .swiper-container",
      {
        modules: [Pagination],

        // eslint-disable-line
        // Optional parameters
        grabCursor: true,
        direction: "horizontal",
        loop: true,
        speed: 3000,
        slidesPerView: 1,

        // pagination dots
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      }
    );
    /* eslint-enable no-unused-vars, no-undef */
  }

  /* eslint-disable */
  progress(swiper, progress) {
    const currentProgressPercentage = progress.progress * 100;
    Array.from(swiper.querySelectorAll(".swiper-current-progress")).forEach(
      (el) => {
        el.style.width = currentProgressPercentage + "%";
      }
    );
  }
  /* eslint-enable */
}

export default Slider;
